export const ChevronDownIcon = ({ ...props }) => {
  return (
    <svg
      height="24"
      preserveAspectRatio="xMinYMin"
      viewBox="-5 -8 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m7.071 5.314 4.95-4.95a1 1 0 1 1 1.414 1.414l-5.657 5.657a1 1 0 0 1 -1.414 0l-5.657-5.657a1 1 0 1 1 1.414-1.414z" />
    </svg>
  );
};
